import {TOKENS} from '../../tokens'

export const toggleButton = {
  dark: {
    selectedBgHover: TOKENS.dark.contrast_800,
    selectedBgDisabled: TOKENS.dark.contrast_500,
    disabledBg: TOKENS.dark.contrast_100,
  },
  light: {
    selectedBgHover: TOKENS.light.contrast_800,
    selectedBgDisabled: TOKENS.light.contrast_500,
    disabledBg: TOKENS.light.contrast_100,
  },
} as const
